import {createSlice} from "@reduxjs/toolkit";

const initialState = false;

const showRequestAssistanceSlice = createSlice({
    name: 'showRequestAssistance',
    initialState,
    reducers: {
        openRequestAssistanceModal: (_, __) => true,
        closeRequestAssistanceModal: (_, __) => false,
    },
});

export const {openRequestAssistanceModal, closeRequestAssistanceModal} = showRequestAssistanceSlice.actions;
export default showRequestAssistanceSlice.reducer;
